module.exports = __webpack_public_path__ + "static/media/Medcare Hospital.178491de.jpg";